import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table";
import {
  Wrapper,
  StyledTable,
  Thead,
  Th,
  Tbody,
  Tr,
  Td,
  EmptyState,
  LoadingOverlay,
} from "./styles.table";

export default function Table({
  columns,
  data,
  getRowId,
  isLoading = false,
  emptyMessage = "No results found",
  onRowClick,
}) {
  const table = useReactTable({
    data,
    columns,
    getRowId,
    getCoreRowModel: getCoreRowModel(),
  });

  const rows = table.getRowModel().rows;

  return (
    <Wrapper>
      <StyledTable>
        <Thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <Tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <Th
                  key={header.id}
                  $sticky={header.column.columnDef.meta?.sticky}
                  $width={header.column.columnDef.meta?.width}
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {rows.length === 0 && !isLoading && (
            <tr>
              <td colSpan={columns.length}>
                <EmptyState>{emptyMessage}</EmptyState>
              </td>
            </tr>
          )}
          {rows.map((row, index) => (
            <Tr key={row.id} $striped={index % 2 === 1} onClick={() => onRowClick?.(row.original)}>
              {row.getVisibleCells().map((cell) => (
                <Td
                  key={cell.id}
                  $sticky={cell.column.columnDef.meta?.sticky}
                  $width={cell.column.columnDef.meta?.width}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </StyledTable>
      {isLoading && <LoadingOverlay />}
    </Wrapper>
  );
}
